import React from 'react';
import UserIdentity from './userIdentity';
import Utils from 'context/utils';

// Shared AG Grid "caller" column cell renderer: the principal that started an execution.
//
// It reads the row, never the network. The user record is attached to the row by whoever loaded it
// (`data.caller`), because `Api.usersIdGet` memoises resolved responses but does not dedupe requests
// still in flight — a renderer that fetched its own user would fire one request per row on first paint,
// twenty of them for twenty executions by the same person.
//
// `data.caller` absent is ordinary rather than exceptional: it is every row's state until resolution
// lands, and the permanent state of a caller that cannot be fetched. UserIdentity's fallback renders the
// raw id for both, which beats an empty cell where a name belongs.
//
// AgGridReact does not render meaningfully under jsdom, so this is exported and tested directly.
export function callerCellRenderer(params) {
  const userId = params.data ? params.data["user_id"] : null;
  if ( !userId ) {
    return null;
  }
  // `bh-grid-identity` is the cell's promise to the identity that it has one line and no more.
  return (
    <span className="bh-grid-identity">
      <UserIdentity user={params.data["caller"]} fallback={userId} strong={false} />
    </span>
  );
}

/**
 * The caller column's VALUE — the resolved name, falling back to the raw id.
 *
 * Not the id itself, and this is the whole reason the column ever showed a uuid: AG Grid repaints a
 * cell when its value changes, and the loader attaches `caller` to the row without touching
 * `user_id`. A column reading the id therefore never changes value and never repaints, so every cell
 * kept its first paint — the fallback — however long ago the lookup landed.
 *
 * Sorting and filtering follow the name as a consequence, which is what someone typing a person's
 * name into that filter box is asking for.
 */
export function callerValueGetter(params) {
  const data = params.data;
  if ( !data ) {
    return null;
  }
  return Utils.displayName(data["caller"], data["user_id"]);
}
